import { render, staticRenderFns } from "./OnCall.vue?vue&type=template&id=299e91ce&scoped=true&"
import script from "./OnCall.vue?vue&type=script&lang=js&"
export * from "./OnCall.vue?vue&type=script&lang=js&"
import style0 from "./OnCall.vue?vue&type=style&index=0&id=299e91ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299e91ce",
  null
  
)

export default component.exports